import React, { Component, Fragment } from 'react';
import { Button, Grid, GridRow, GridColumn, Checkbox } from 'semantic-ui-react';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { withRouter } from 'react-router';
import ReactTable from 'react-table';

import { setAssignCurrentUser } from './state/actions';
import * as actions from './state/actions';

import { createToast, toastType } from 'Common/ToastHelper';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { SUPPORT_USERNAME } from 'Common/Constants';
import { Filter, Main } from 'Containers';
import { YesNoDialog } from '../../components/dialogs/YesNoDialog';
import { FieldEnum } from 'Common/FieldEnum';
import { ResetModal } from './components/ResetModal';
import { EditModal } from './components/EditModal';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import 'PageStyles/usersetup/index.less';

class UserSetupContainer extends Component {
  state = {
    modalData: {},
    showModal: false,
    showResetModal: false,
    isEditValid: true,
    showDeleteModal: false,
    filtered: [],
  };

  componentWillMount() {
    this.props.getUserSetup(this.props.showInactive);
    this.props.getRoles();
  }

  //Edit user
  onEditClick = row => {
    this.setState({ modalData: row, showModal: true, isEditValid: true });
  };

  onEditClose = () => {
    this.setState({ showModal: false });
  };

  handleEditSubmit = values => {
    const thisUser = _.find(this.props.userSetup.Data, { Id: values.id });
    let updatedUser = {
      ...thisUser,
      UserName: values[FieldEnum.Username],
      FirstName: values[FieldEnum.FirstName],
      LastName: values[FieldEnum.LastName],
      RoleId: values[FieldEnum.RoleId],
      Email: values[FieldEnum.Email],
      IsActive: !values[FieldEnum.IsActive],
    };

    if (values[FieldEnum.Id] === 0) {
      updatedUser = {
        ...updatedUser,
        Password: values[FieldEnum.Password],
      };
    }
    return this.props
      .postUsermaster(updatedUser)
      .then(result => {
        createToast(
          toastType.success,
          'Success',
          'User saved successfully.',
          true
        );
        this.setState({ showModal: false });
        this.props.getUserSetup(this.props.showInactive);
      })
      .catch(err => {
        createToast(toastType.error, 'Error', err[0].Message, true);
        //eslint-disable-next-line
      });
  };

  //Add user
  onAddUserClick = () => {
    this.setState({
      modalData: {
        Id: 0,
        IsActive: true,
        RoleId: 4,
      },
      showModal: true,
      isEditValid: false,
    });
  };

  //Reset user
  onResetClick = row => {
    this.setState({ modalData: row, showResetModal: true });
  };

  onResetClose = () => {
    this.setState({ showResetModal: false });
  };

  handleResetSubmit = values => {
    this.setState({ showModal: false });

    return this.props
      .postResetPassword(values)
      .then(result => {
        this.setState({ showResetModal: false });
        createToast(
          toastType.success,
          'Success',
          "The user's password has been reset.",
          true
        );
        this.props.getUserSetup(this.props.showInactive);
      })
      .catch(err => {
        createToast(toastType.error, 'Error', err[0].Message, true);
      });
  };

  //Delete User
  onDeleteClick = row => {
    this.props.clearErrors();
    this.setState({ showDeleteModal: true, modalData: row });
  };

  onDeleteClose = () => {
    this.setState({ showDeleteModal: false });
    //not being able to delete we set inactive so now need to refresh
    this.props.getUserSetup(this.props.showInactive);
  };

  handleDeleteSubmit = id => {
    const { getUserSetup, showInactive } = this.props;

    this.setState({ showDeleteModal: false });

    return this.props
      .postDeleteUser(id)
      .then(result => {
        getUserSetup(showInactive);

        createToast(
          toastType.success,
          'Success',
          'The user has been deleted.',
          true
        );
      })
      .catch(err => {
        getUserSetup(showInactive);

        createToast(toastType.error, 'Error', err[0].Message, true);
      });
  };

  onAssignSitesClick = row => {
    this.props.history.push(`/usersetup/assignusers/${row.Id}/${row.UserName}`);
  };

  //Filter Change
  onFilterChange = e => {
    const newValue = !this.props.showInactive;
    this.props.setShowInactive(newValue);
    this.props.setFilteredData(newValue);
  };

  handleDialog(result) {
    if (result) {
      this.handleDeleteSubmit(this.state.modalData && this.state.modalData.Id);
    } else {
      this.setState({ showDeleteModal: false });
    }
  }

  isSupportUser = row => {
    return row && row.UserName.toLowerCase() === SUPPORT_USERNAME.toLowerCase();
  };

  menuOptions = [
    {
      icon: 'pencil',
      text: 'Edit',
      handler: this.onEditClick,
      disabledWhen: row => this.isSupportUser(row),
    },
    {
      icon: 'repeat flipped horizontally',
      text: 'Reset Password',
      handler: this.onResetClick,
      disabledWhen: row => this.props.isReadOnly || this.isSupportUser(row),
    },
    {
      icon: 'trash',
      text: 'Delete User',
      className: 'danger',
      handler: this.onDeleteClick,
      disabledWhen: row => this.props.isReadOnly || this.isSupportUser(row),
    },
    {
      icon: 'building outline',
      text: 'Assign Site(s)',
      handler: this.onAssignSitesClick,
    },
  ];

  getUserDesc = rowInfo => {
    const role = this.props.roles.find(
      element => element.Id === rowInfo.RoleId
    );
    if (role) {
      return role.Description;
    }
    return '';
  };

  render() {
    const { modalData, showModal, showResetModal } = this.state;
    const { isReadOnly } = this.props;

    const data = this.props.filteredData || [];

    return (
      <Fragment>
        <Filter title={'User Setup'}>
          <Grid>
            <GridRow>
              <GridColumn width="8" floated="left">
                <Checkbox
                  label="Show Inactive"
                  toggle
                  checked={this.props.showInactive}
                  onChange={this.onFilterChange}
                />
              </GridColumn>
              <GridColumn width="8" floated="right" textAlign="right">
                <Button
                  content="Add User"
                  disabled={isReadOnly}
                  onClick={this.onAddUserClick}
                />
              </GridColumn>
            </GridRow>
          </Grid>
        </Filter>
        <Main style={{ paddingBottom: '50px' }}>
          <Button
            className={'clear-filters-button'}
            content="Clear Filters"
            onClick={() => this.setState({ filtered: [] })}
          />
          <ReactTable
            loading={this.props.isUserGridLoading}
            minRows={0}
            data={data}
            resizable={false}
            className="-striped -highlight"
            defaultFilterMethod={caseInsensitiveFilter}
            filtered={this.state.filtered}
            onFilteredChange={filtered => this.setState({ filtered })}
            getTrProps={(state, rowInfo, column) => {
              return {
                style: {
                  color:
                    rowInfo &&
                    rowInfo.original &&
                    rowInfo.original.IsActive === true
                      ? ''
                      : 'red',
                },
              };
            }}
            defaultSorted={[
              {
                id: 'LastName',
                desc: false,
              },
              {
                id: 'FirstName',
                desc: false,
              },
            ]}
            columns={[
              {
                columns: [
                  {
                    Header: 'UserName',
                    accessor: 'UserName',
                    filterable: true,
                  },
                  {
                    Header: 'User Role',
                    id: 'userRole',
                    accessor: this.getUserDesc,
                    filterable: true,
                  },
                  {
                    Header: 'Last Name',
                    accessor: 'LastName',
                    filterable: true,
                  },
                  {
                    Header: 'First Name',
                    accessor: 'FirstName',
                    filterable: true,
                  },

                  {
                    width: 50,
                    sortable: false,
                    Cell: gridProps => {
                      return GridContextMenu({
                        gridProps,
                        options: this.menuOptions,
                      });
                    },
                  },
                ],
              },
            ]}
          />

          <EditModal
            showEditModal={showModal}
            onClose={this.onEditClose}
            handleEditSubmit={this.handleEditSubmit}
            roles={this.props.roles}
            modalData={modalData}
            isEditValid={this.state.isEditValid}
            userSetup={this.props.userSetup}
            isReadOnly={isReadOnly}
            currentUserName={this.props.userInfo.userName}
          />

          <ResetModal
            showResetModal={showResetModal}
            onResetClose={this.onResetClose}
            handleSubmit={this.handleResetSubmit}
            modalData={modalData}
            onClose={this.onResetClose}
          />
          <YesNoDialog
            showDialog={this.state.showDeleteModal}
            title="Delete User"
            question={` Are you sure you want to delete this user: ${modalData.UserName}?`}
            yesCallback={() => {
              this.handleDialog(true);
            }}
            noCallback={() => {
              this.handleDialog(false);
            }}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ UserSetupState, SecurityState }) => {
  return {
    userSetup: UserSetupState.userSetup,
    filteredData: UserSetupState.filteredData,
    roles: UserSetupState.roles,
    showInactive: UserSetupState.showInactive,
    assignSiteData: UserSetupState.assignSiteData,
    assignCurrentUser: UserSetupState.assignCurrentUser,
    isUserGridLoading: UserSetupState.isUserGridLoading,
    isAssignGridLoading: UserSetupState.isAssignGridLoading,
    userInfo: SecurityState.userInfo,
  };
};

export const UserSetup = withRouter(
  connect(mapStateToProps, { ...actions, setAssignCurrentUser })(
    UserSetupContainer
  )
);



// WEBPACK FOOTER //
// ./src/pages/usersetup/UserSetup.js